<template>
  <div class="claimed-detail">
    <div class="title payment">
      <div class="title-area">1. 결제 상세 {{ payDetailInfo }}</div>
      <div class="btn-area"><button class="btn" @click="goList">목록</button></div>
    </div>
    <div class="detail payment">
      <div class="image-area">
        <div class="images">
          <div class="image scroll" ref="image">
            <img
              v-if="selectedImage"
              :src="selectedImage.src"
              :width="selectedImage.width * selectedImage.scale + 'px'"
              :height="selectedImage.height * selectedImage.scale + 'px'"
              alt
            />
            <div v-else>
              {{ errMsg }}
            </div>
          </div>
          <Spinner
            class="spinner"
            v-if="loadingImage"
            width="120"
            height="120"
            size="8"
          ></Spinner>

          <!-- TODO
          <div class="sub-image scroll">
            <div v-for="(img, camera, i) in image" :key="camera">
              <div v-if="i < 6">
                <img v-if="img" :src="img.src" alt
                  :class="selectedCamera === camera ? 'selected' : ''"
                  @click="selectCamera(camera)"/>
                <img v-else src="/static/img/ico-pending-grey.png" alt
                  :class="selectedCamera === camera ? 'selected' : ''"
                  @click="selectCamera(camera)"/>
              </div>
            </div>
          </div>
          -->
          <!-- TODO
          <div class="sub-image scroll">
            <div>
              <img v-if="image.video0" :src="image.video0.src" alt
                :class="selectedCamera === 'video0' ? 'selected' : ''"
                @click="selectCamera('video0')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video0' ? 'selected' : ''"
                @click="selectCamera('video0')"/>
            </div>
            <div>
              <img v-if="image.video2" :src="image.video2.src" alt
                :class="selectedCamera === 'video2' ? 'selected' : ''"
                @click="selectCamera('video2')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video2' ? 'selected' : ''"
                @click="selectCamera('video2')"/>
            </div>
            <div>
              <img v-if="image.video4" :src="image.video4.src" alt
                :class="selectedCamera === 'video4' ? 'selected' : ''"
                @click="selectCamera('video4')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video4' ? 'selected' : ''"
                @click="selectCamera('video4')"/>
            </div>
            <div>
              <img v-if="image.video6" :src="image.video6.src" alt
                :class="selectedCamera === 'video6' ? 'selected' : ''"
                @click="selectCamera('video6')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video6' ? 'selected' : ''"
                @click="selectCamera('video6')"/>
            </div>
            <div>
              <img v-if="image.video8" :src="image.video8.src" alt
                :class="selectedCamera === 'video8' ? 'selected' : ''"
                @click="selectCamera('video8')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video8' ? 'selected' : ''"
                @click="selectCamera('video8')"/>
            </div>
            <div>
              <img v-if="image.video10" :src="image.video10.src" alt
                :class="selectedCamera === 'video10' ? 'selected' : ''"
                @click="selectCamera('video10')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video10' ? 'selected' : ''"
                @click="selectCamera('video10')"/>
            </div>
          </div>
          -->


        </div>

        <input
          v-if="selectedURLs && selectedURLs.length !== 0"
          v-model="imageIndex"
          type="range"
          min="0"
          :max="selectedURLs.length - 1"
          class="slider"
        />
      </div>


      <!-- TODO -->
      <div class="subimages scroll">
        <!--
        <div v-for="(img, camera, i) in computedImage" :key="camera">
          <div v-if="i < cameraCount">
            <img v-if="img" :src="img.src" alt
              :class="selectedCamera === camera ? 'selected' : ''"
              @click="selectCamera(camera)"/>
            <img v-else src="/static/img/ico-pending-grey.png" alt
              :class="selectedCamera === camera ? 'selected' : ''"
              @click="selectCamera(camera)"/>
          </div>
        </div>
        -->
        <div v-for="(img, camera) in computedImage" :key="camera">
          <img v-if="img" :src="img.src" alt
            :class="selectedCamera === camera ? 'selected' : ''"
            @click="selectCamera(camera)"/>
          <img v-else src="/static/img/ico-pending-grey.png" alt
            :class="selectedCamera === camera ? 'selected' : ''"
            @click="selectCamera(camera)"/>
        </div>
      </div>


      <div class="products scroll">
        <div
          v-if="
            !claimed.products ||
            Object.keys(claimed.products).length === 0
          "
          class="type"
        >
          상품이 없습니다.
        </div>

        <div v-else>
          <div v-for="(products, type) in claimed.products" :key="type">
            <div class="type">
              [ {{ type }} ]
            </div>

            <div class="header">
              <div class="preview"></div>
              <div class="name">상품명</div>
              <div class="beforeCount">기존 결제 수량</div>
              <div class="afterCount">변경할 수량</div>
              <div class="afterCount">판매 가격</div>
              <div class="price">결제 금액</div>
            </div>
            <div
              v-for="product in products"
              class="product"
              :key="product.productID"
              :style="product.count !== product.afterCount ? 'background-color:#b0bec5;': ''"
            >
              <div class="preview">
                <ProductThumbnail :product="product" :zoom="true"/>
              </div>
              <div class="name">
                {{ product.productName }}
              </div>

              <div class="beforeCount">
                <div class="count">
                  {{ product.count }}
                </div>
              </div>
              <div class="ctrl afterCount"  :style="product.count !== product.afterCount ? 'color:red': ''">
                <button class="btn" @click="subProductCount(product)">-</button>
                <div class="count" :class="product.afterCount === 0 ? 'zero' : ''">
                  {{ product.afterCount }}
                </div>
                <button class="btn" @click="addProductCount(product)">+</button>
              </div>
              <div class="salePrice">{{ Number(product.salePrice).toLocaleString() }}원</div>
              <div class="price" :style="product.count !== product.afterCount ? 'color:red': ''">{{ Number(product.price).toLocaleString() }}원</div>
            </div>
          </div>
          <div class="total">
            <div v-if="searchType === 'refund'" class="title">결제 금액 합계</div>
            <div v-else class="title">재결제 금액 합계</div>
            <div class="price">{{ Number(totalPrice).toLocaleString() }}원</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title customer">
        <div class="title-area">2. 고객 정보 입력</div>
      </div>
      <div class="detail customer">
        <div v-if="searchType === 'nonpayment'" class="row">
          <div class="col header">토큰ID</div>
          <div class="col input wide">
            {{ tokenID }}
          </div>
        </div>
        <div class="row">
          <div class="col header">고객 이름</div>
          <div class="col input">
            <input
              v-model="userName"
              type="text"
            />
          </div>
          <div class="col header">연락처</div>
          <div class="col input">
            <input
              v-model="userMobile"
              type="number"
            />
          </div>
        </div>
        <div v-if="searchType === 'refund'" class="row">
          <div class="col header">은행명</div>
          <div class="col input wide">
            <input
              v-model="bankName"
              type="text"
            />
          </div>
          <div class="col header">계좌번호</div>
          <div class="col input wide">
            <input
              v-model="accountNum"
              type="number"
            />
          </div>
        </div>
        <div v-if="true" class="row">
          <div class="col header">기타 메모</div>
          <div class="col input wide">
            <input
              v-model="memo"
              type="text"
            />
          </div>
        </div>
      </div>
      <div class="title pay">
        <div class="title-area">3. 결제 처리</div>
      </div>
      <div class="detail pay">
        <div v-if="searchType==='claim'" class="row">
          <div class="col header">구매 상품</div>
          <div class="col list" @click="togglePayDetail">
            <span v-if="newPaymentDetails.length > 0">{{ newPaymentDetails[0].productName }} {{ newPaymentDetails.length > 1 ? ' 외 '+(newPaymentDetails.length-1)+'건' : ''}}</span>
            <img v-if="isOpen" src="/static/img/ico-chevron-down-white.png">
            <img v-else src="/static/img/ico-chevron-right-white.png">
          </div>
          <div class="col header">승인 취소 금액</div>
          <div class="col approvePrice">{{ Number(this.claimed.approvePrice).toLocaleString() }}원</div>
          <div class="col header red first">재결제 금액 합계</div>
          <div class="col totalPrice red last">{{ Number(this.totalPrice).toLocaleString() }}원</div>
          <div v-if="!executeLoading" class="col btn">
            <button v-if="totalPrice > 0" class="btn blue" :disabled="executeLoading" @click="executeConfirmRebill">재승인</button>
            <button v-else class="btn redpink" :disabled="executeLoading" @click="excuteConfirmCancel">승인취소</button>
          </div>
          <div v-else class="col btn">
            <ButtonLoading style="margin-top:5px;margin-left:80px"></ButtonLoading>
          </div>
        </div>
        <div v-else-if="searchType==='refund'" class="row">
          <div class="col header">구매 상품</div>
          <div class="col list" @click="togglePayDetail">
            <span v-if="newPaymentDetails.length > 0">{{ newPaymentDetails[0].productName }} {{ newPaymentDetails.length > 1 ? ' 외 '+(newPaymentDetails.length-1)+'건' : ''}}</span>
            <img v-if="isOpen" src="/static/img/ico-chevron-down-white.png">
            <img v-else src="/static/img/ico-chevron-right-white.png">
          </div>
          <div class="col header">승인 금액</div>
          <div class="col approvePrice">{{ Number(this.claimed.approvePrice).toLocaleString() }}원</div>
          <div class="col header red first">환불 금액 합계</div>
          <div class="col totalPrice red last">{{ Number(this.refundPrice).toLocaleString() }}원</div>
          <div v-if="!executeLoading" class="col btn">
            <button class="btn blue" :disabled="executeLoading" @click="executeConfirmRefund">저장</button>
          </div>
          <div v-else class="col btn">
            <ButtonLoading style="margin-top:5px;margin-left:80px"></ButtonLoading>
          </div>
        </div>
        <div v-else-if="searchType==='nonpayment'" class="row">
          <div class="col header">구매 상품</div>
          <div class="col list" @click="togglePayDetail">
            <span v-if="newPaymentDetails.length > 0">{{ newPaymentDetails[0].productName }} {{ newPaymentDetails.length > 1 ? ' 외 '+(newPaymentDetails.length-1)+'건' : ''}}</span>
            <img v-if="isOpen" src="/static/img/ico-chevron-down-white.png">
            <img v-else src="/static/img/ico-chevron-right-white.png">
          </div>
          <div class="col header red first">결제 금액 합계</div>
          <div class="col totalPrice red last">{{ Number(this.totalPrice).toLocaleString() }}원</div>
          <div v-if="!executeLoading" class="col btn">
            <button v-if="tokenID && tokenID.length > 0" class="btn blue" :disabled="executeLoading" @click="executeConfirmNonpayment">승인</button>
            <button v-else class="btn blue" :disabled="executeLoading" @click="executeConfirmNonpayment">저장</button>
          </div>
          <div v-else class="col btn">
            <ButtonLoading style="margin-top:5px;margin-left:80px"></ButtonLoading>
          </div>
        </div>

      </div>
      <div v-if="isOpen" class="detail payDetail">
        <div class="row header">
          <div class="col no">No.</div>
          <div class="col name">상품명</div>
          <div class="col salePrice">판매 가격</div>
          <div class="col beforeCount">기존 결제 수량</div>
          <div class="col differenceCount">변경할 수량</div>
          <div class="col afterCount">변경된 수량</div>
          <div class="col beforePrice">기존 결제 금액</div>
          <div class="col diffrencePrice">변경할 결제 금액</div>
          <div v-if="searchType==='claim'" class="col afterPrice">재결제 금액</div>
        </div>
        <div
          class="row item"
          v-for="(newPaymentDetail, index) in newPaymentDetails"
          :key="index"
        >
          <div class="col no">{{ newPaymentDetail.no }}</div>
          <div class="col name">{{ newPaymentDetail.productName }}</div>
          <div class="col salePrice">{{ Number(newPaymentDetail.salePrice).toLocaleString() }}</div>
          <div class="col beforeCount">{{ newPaymentDetail.beforeCount }}</div>
          <div class="col differenceCount" :class="newPaymentDetail.diffrenceCount > 0 ? 'on' : ''">{{ newPaymentDetail.diffrenceCount }}</div>
          <div class="col afterCount">{{ newPaymentDetail.productCount }}</div>
          <div class="col beforePrice">{{ Number(newPaymentDetail.beforePrice).toLocaleString() }}</div>
          <div class="col diffrencePrice" :class="newPaymentDetail.diffrencePrice > 0 ? 'on' : ''">{{ Number(newPaymentDetail.diffrencePrice).toLocaleString() }}</div>
          <div v-if="searchType==='claim'" class="col afterPrice">{{ Number(newPaymentDetail.price).toLocaleString() }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-alert */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable no-continue */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-unused-vars */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';
import ProductThumbnail from '@/components/product/ProductThumbnail';

export default {
  props: [
    'searchType',
    'selectedID',
    'uID',
  ],
  components: {
    ButtonLoading,
    ProductThumbnail,
  },
  data: () => ({
    beforeSelectedID: null,
    loading: true,
    interval: null,
    // initData begin
    claimed: {},
    imageIndex: 0,
    image: {},
    selectedImage: null,
    selectedCamera: 'video0',
    selectedURLs: null,
    cameraCount: 0,
    loadingImage: true,
    // initData end
    errMsg: '이미지가 없습니다',
    totalPrice: 0,
    isOpen: false,
    newPaymentDetails: [],
    userName: null,
    userMobile: null,
    memo: null,
    bankName: null,
    accountNum: null,
    refundPrice: 0,
    executeLoading: false,
    tokenID: null,
  }),
  created() {
    if (!this.selectedID) {
      this.selectedID = this.$route.query.selectedID;
    }

    this.initData();

    window.addEventListener('resize', this.getImageScale);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getImageScale);

    //
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
  watch: {
    selectedID: {
      handler() {
        if (!this.selectedID) {
          this.selectedID = this.$route.query.selectedID;
        }

        if (!this.selectedID) {
          return;
        }

        this.fetchPay(this.selectedID, false);
      },
      immediate: true,
    },
    claimed: {
      handler() {
        if (!this.claimed.ID) {
          this.$emit('setclaimed', null);
        }
        this.$emit('setclaimed', this.claimed);
      },
      immediate: true,
      deep: true,
    },
    imageIndex() {
      if (
        !this.claimed.imageURLs ||
        !this.selectedURLs ||
        this.selectedURLs.length <= this.imageIndex
      ) {
        return;
      }

      this.getImage(this.claimed.imageURLs, this.imageIndex);
    },
  },
  computed: {
    computedImage() {
      const image = {};
      for (let i = 0; i < 30; i++) { // total 30
        const camera = `video${i * 2}`;
        if (this.image[camera]) {
          image[camera] = this.image[camera];
        }
      }
      return image;
    },
    payDetailInfo() {
      if (!this.loading && this.claimed.paymentAt) {
        return `${this.claimed.paymentAt} | ${this.claimed.paymentPrice}원 | ${this.claimed.approveType} | ${this.claimed.place} | ${this.claimed.companyName}`;
      }

      return '';
    },
  },
  methods: {
    initData() {
      this.claimed = {
        ID: null,
        deviceID: null,
        products: null,
        paymentAt: null,
        paymentPrice: null,
        approveType: null,
        approvePrice: null,
        address: null,
        place: null,
        companyID: null,
        companyName: null,
        imageURLs: null,
        paymentDetails: [],
      };
      this.imageIndex = 0;
      this.image = { // total 30
        video0: null,
        video2: null,
        video4: null,
        video6: null,
        video8: null,
        video10: null,
        video12: null,
        video14: null,
        video16: null,
        video18: null,
        video20: null,
        video22: null,
        video24: null,
        video26: null,
        video28: null,
        video30: null,
        video32: null,
        video34: null,
        video36: null,
        video38: null,
        video40: null,
        video42: null,
        video44: null,
        video46: null,
        video48: null,
        video50: null,
        video52: null,
        video54: null,
        video56: null,
        video58: null,
      };
      this.selectedImage = null;
      this.selectedCamera = 'video0';
      this.selectedURLs = null;
      this.cameraCount = 0;
      this.loadingImage = true;
      this.totalPrice = 0;
    },
    async fetchPay(ID, polling) {
      this.loading = true;
      if (this.beforeSelectedID !== ID) {
        this.initData();
        this.beforeSelectedID = ID;
      }

      try {
        const claimed = {
          ID: null,
          deviceID: null,
          products: null,
          paymentAt: null,
          paymentPrice: null,
          approveType: null,
          approvePrice: null,
          address: null,
          place: null,
          companyID: null,
          companyName: null,
          imageURLs: null,
          paymentDetails: [],
        };
        let cameraCount = 0;

        let url = `${Configuration.value(
          'CPAYMENT_ADDRESS',
        )}/api/v1/cpayment/payment/${ID}`;

        //
        let expire = false;
        if (this.searchType === 'claim') {
          url += '/claim';
        } else if (this.searchType === 'refund') {
          url += '/claim';
          expire = true;
        } else if (this.searchType === 'nonpayment') {
          url += '/nonpayment';
        } else {
          alert(`searchType(${this.searchType}) not supported`);
          return;
        }

        const pay = await this.$http.post(
          `${url}`,
          {
            uID: this.uID,
            expire,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (pay.status !== 200 && pay.status !== 408) {
          throw new Error(`Response status is "${pay.status}"`);
        }
        if (pay.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${pay.data.resultCode}"`);
        }

        this.tokenID = pay.data.payment.tokenID;
        claimed.ID = pay.data.payment.paymentID;
        claimed.deviceID = pay.data.payment.deviceID;
        claimed.paymentAt = pay.data.payment.paymentAt ? this.$moment(pay.data.payment.paymentAt).format('YYYY-MM-DD HH:mm:ss') : '-';
        claimed.paymentPrice = pay.data.payment.paymentPrice;
        claimed.approveType = this.$getConstName('approveType', pay.data.payment.approveType);
        claimed.approvePrice = pay.data.payment.approvePrice;
        claimed.address = pay.data.payment.address;
        claimed.place = pay.data.payment.place;
        claimed.companyID = pay.data.payment.companyID;
        claimed.companyName = await this.getCompanyData(claimed.companyID);
        claimed.paymentDetails = pay.data.payment.paymentDetails;

        if (pay.data.payment.paymentImages) {
          const urls = {};
          for (let i = 0; i < pay.data.payment.paymentImages.length; i++) {
            const fileURL = pay.data.payment.paymentImages[i].fileURL;
            const split = fileURL.split('/');
            if (split.length < 2) {
              continue;
            }
            const videoIndex = split[split.length - 2];

            if (
              fileURL.startsWith('https://') ||
              fileURL.startsWith('http://')
            ) {
              if (!urls[videoIndex]) {
                cameraCount++;
                urls[videoIndex] = [];
              }
              urls[videoIndex].push(fileURL);
              continue;
            }

            if (!urls[videoIndex]) {
              cameraCount++;
              urls[videoIndex] = [];
            }
            urls[videoIndex].push(
              `${Configuration.value('CPAYMENT_ADDRESS')}/${fileURL}`,
            );
          }

          const keys = Object.keys(urls);
          for (let i = 0; i < keys.length; i++) {
            urls[keys[i]].sort();
          }
          claimed.imageURLs = urls;
        }

        if (this.claimed.ID !== claimed.ID && claimed.deviceID) {
          const products = {};
          for (let i = 1; ; i++) {
            const device = await this.$http.get(
              `${Configuration.value(
                'CPRODUCT_ADDRESS',
              )}/api/v1/cproduct/device/${
                claimed.deviceID
              }/product/list?page=${i}&limit=500&showDeleted=false`,
              {
                headers: {
                  Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
                },
              },
            );
            if (device.status !== 200) {
              if (device.status === 204) {
                break;
              }
              throw new Error(`Response stauts is "${device.status}"`);
            }
            if (device.data.resultCode !== '0000') {
              throw new Error(`ResultCode is "${device.data.resultCode}"`);
            }

            for (let j = 0; j < device.data.products.length; j++) {
              const product = device.data.products[j];

              const cp = JSON.parse(JSON.stringify(product));
              let paymentDetail = null;
              if (claimed.paymentDetails) {
                paymentDetail = claimed.paymentDetails.find(payment => payment.productID === cp.productID);
              }

              if (paymentDetail) {
                cp.count = paymentDetail.productCount;
                cp.afterCount = paymentDetail.productCount;
                cp.price = paymentDetail.salePrice * paymentDetail.productCount;
              } else {
                cp.count = 0;
                cp.afterCount = 0;
                cp.price = 0;
              }

              if (product.productType in products) {
                products[product.productType].push(cp);
              } else {
                products[product.productType] = [cp];
              }
            }

            // this.totalPrice = 2000; // TODO ????
          }
          claimed.products = products;
        } else {
          claimed.products = this.claimed.products;
        }

        //
        this.claimed = claimed;
        if (!this.selectedURLs) {
          this.selectedCamera = 'video0';
          if (claimed.imageURLs && claimed.imageURLs.video0) {
            this.selectedURLs = this.claimed.imageURLs.video0;
          } else {
            this.selectedURLs = null;
          }
        }
        this.cameraCount = cameraCount;
        if (this.searchType === 'claim' || this.searchType === 'refund') {
          this.totalPrice = claimed.approvePrice;
        } else if (this.searchType === 'nonpayment') {
          this.totalPrice = claimed.paymentPrice;
        }

        if (!claimed.paymentDetails) {
          this.caculateTotalPrice();
        }
        this.makeProductDetail();
        this.loading = false;

        if (this.claimed.imageURLs) {
          this.getImage(this.claimed.imageURLs, this.imageIndex);
        } else {
          this.loadingImage = false;
        }
        this.$nextTick(this.setSliderWidth);
      } catch (e) {
        this.loading = false;
        this.loadingImage = false;

        if (e.response) {
          if (e.response.status === 409) {
            if (!polling) {
              alert(
                '처리 중인 작업입니다.\n다른 작업을 선택하거나, 새로고침 해주세요.',
              );
            }
            this.$emit('refresh');
            return;
          }
        }

        if (!polling) {
          alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        }
        console.error(e);
      }
    },
    async getCompanyData(companyID) {
      let companyName = null;
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${companyID}?withDivisions=false`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          if (result.status === 204) {
            companyName = null;

            return companyName;
          }

          throw new Error(`response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`resultcode is "${result.data.resultCode}"`);
        }

        companyName = result.data.company.companyName;
      } catch (e) {
        companyName = null;
        console.error(e);
      }
      return companyName;
    },
    setSliderWidth() {
      if (!this.selectedURLs) {
        return;
      }

      const elems = document.getElementsByClassName('slider');
      if (elems.length !== 1) {
        return;
      }

      const slider = elems[0];
      slider.style.setProperty(
        '--slider-width',
        `calc(100%/${this.selectedURLs.length}`,
      );
    },
    async getImage(urls, index) {
      try {
        const keys = Object.keys(urls);
        for (let i = 0; i < keys.length; i++) {
          if (urls[keys[i]].length <= index) {
            this.image[keys[i]] = null;
            continue;
          }

          // TODO
          if (this.selectedCamera !== keys[i] && this.image[keys[i]]) {
            continue;
          }

          const url = urls[keys[i]][index];
          if (!url) {
            continue;
          }
          const res = await this.$http.get(url, {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
            responseType: 'arraybuffer',
          });
          if (res.status !== 200) {
            throw new Error(`Response stauts is "${res.status}"`);
          }

          const src = `data:image/jpeg;base64,${Buffer.from(
            res.data,
            'binary',
          ).toString('base64')}`;
          const img = new Image();
          img.onload = () => {
            this.image[keys[i]] = {
              src,
              width: img.width,
              height: img.height,
              scale: 1,
            };

            //
            if (this.selectedCamera === keys[i]) {
              this.selectedImage = this.image[keys[i]];
            }
            this.loadingImage = false;

            this.getImageScale();
          };
          img.onerror = (e) => {
            console.error('image load error', e);
            if (this.selectedCamera === keys[i]) {
              this.selectedImage = null;
            }
            this.loadingImage = false;
          };
          img.src = src;
        }
      } catch (e) {
        console.error('getImage error', e);
        this.imageIndex = 0;
        this.loadingImage = false;

        // alert('이미지를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        this.errMsg = '이미지를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.';
      }
    },
    getImageScale() {
      if (!this.selectedImage) {
        return;
      }
      const elem = this.$refs.image;
      if (!elem) {
        return;
      }

      let scale = 1;
      if (this.selectedImage.width > elem.clientWidth) {
        scale =
          Math.floor((elem.clientWidth / this.selectedImage.width) * 10) / 10;
        if (scale < 0.1) {
          scale = 0.1;
        }
      }
      if (scale > 0.1 && this.selectedImage.height * scale > elem.clientHeight) {
        scale =
          Math.floor((elem.clientHeight / this.selectedImage.height) * 10) / 10;
        if (scale < 0.1) {
          scale = 0.1;
        }
      }

      for (;;) {
        if (scale > 9.9) {
          break;
        }
        const tmp = scale + 0.1;
        if (
          this.selectedImage.width * tmp > elem.clientWidth ||
          this.selectedImage.height * tmp > elem.clientHeight
        ) {
          break;
        }
        scale = tmp;
      }

      this.selectedImage.scale = scale;
    },
    subProductCount(product) {
      // TODO
      // if (this.searchType === 'nonpayment') {
      //   alert('미결제 손실에서는 개수 수정이 불가능합니다.');
      //   return;
      // }
      if (this.searchType === 'refund') {
        // do not check afterCount
      } else if (!product.afterCount) {
        return;
      }
      product.afterCount--;
      product.price = product.salePrice * product.afterCount;
      this.caculateTotalPrice();
      this.makeProductDetail();
    },
    addProductCount(product) {
      // TODO
      // if (this.searchType === 'nonpayment') {
      //   alert('미결제 손실에서는 개수 수정이 불가능합니다.');
      //   return;
      // }
      product.afterCount++;
      product.price = product.salePrice * product.afterCount;
      this.caculateTotalPrice();
      this.makeProductDetail();
    },
    caculateTotalPrice() {
      let totalPrice = 0;

      for (const [key, value] of Object.entries(this.claimed.products)) {
        const products = value;

        for (let i = 0; i < products.length; i++) {
          const product = products[i];

          totalPrice += product.price;
        }
      }

      this.totalPrice = totalPrice;
      this.refundPrice = this.claimed.approvePrice - this.totalPrice;
    },
    makeProductDetail() {
      const newPaymentDetails = [];

      for (const [key, value] of Object.entries(this.claimed.products)) {
        const products = value;

        for (let i = 0; i < products.length; i++) {
          const product = products[i];

          if (product.price > 0 || product.afterCount !== product.count) {
            const beforePrice = product.salePrice * product.count;
            newPaymentDetails.push({
              no: i + 1,
              deviceID: this.claimed.deviceID,
              trayID: product.trayID,
              productID: product.productID,
              productName: product.productName,
              productType: product.productType,
              productCount: product.afterCount,
              beforeCount: product.count,
              diffrenceCount: product.afterCount - product.count,
              supplyPrice: product.supplyPrice,
              salePrice: product.salePrice,
              beforePrice,
              price: product.price,
              diffrencePrice: product.price - beforePrice,
            });
          }
        }
      }

      this.newPaymentDetails = newPaymentDetails;
    },
    selectCamera(camera) {
      this.selectedCamera = camera;
      if (this.claimed.imageURLs && this.claimed.imageURLs[this.selectedCamera]) {
        this.selectedURLs = this.claimed.imageURLs[this.selectedCamera];
      } else {
        this.selectedImage = null;
        this.selectedURLs = null;
      }
      // this.imageIndex = 0; // TODO
      if (this.selectedURLs && this.selectedURLs.length <= this.imageIndex) {
        this.imageIndex = this.selectedURLs.length - 1;
      }
      if (this.claimed.imageURLs) {
        this.getImage(this.claimed.imageURLs, this.imageIndex);
      }
      this.$nextTick(this.setSliderWidth);
    },
    togglePayDetail() {
      this.isOpen = !this.isOpen;
    },
    async executeConfirmRebill() {
      if (!this.validNumber(this.userMobile)) {
        alert('연락처는 숫자만 입력해 주세요.');
        return;
      }
      if (!this.userName || !this.userMobile) {
        alert('고객 정보를 입력 후 실행해주세요.');
        return;
      } else if (!confirm('선택하신 상품으로 재결제 승인을 진행합니다.\n계속 진행하시겠습니까?')) {
        return;
      }

      try {
        this.executeLoading = true;

        const paymentDetails = [];
        for (let i = 0; i < this.newPaymentDetails.length; i++) {
          if (this.newPaymentDetails[i].productCount > 0) {
            paymentDetails.push({
              deviceID: this.claimed.deviceID,
              trayID: this.newPaymentDetails[i].trayID,
              productID: this.newPaymentDetails[i].productID,
              productName: this.newPaymentDetails[i].productName,
              productType: this.newPaymentDetails[i].productType,
              productCount: this.newPaymentDetails[i].productCount,
              supplyPrice: this.newPaymentDetails[i].supplyPrice,
              salePrice: this.newPaymentDetails[i].salePrice,
            });
          }
        }

        const reBiilResult = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/${this.claimed.ID}/rebill`,
          {
            operatorUID: this.uID,
            deviceID: this.claimed.deviceID,
            cancelPrice: parseInt(this.claimed.approvePrice, 10),
            paymentPrice: parseInt(this.totalPrice, 10),
            userName: this.userName,
            userMobile: this.userMobile,
            memo: this.memo,
            paymentDetails,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (reBiilResult.status !== 200) {
          throw new Error(`Response status is "${reBiilResult.status}"`);
        }
        if (reBiilResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${reBiilResult.data.resultCode}"`);
        }
        this.goList();
      } catch (e) {
        alert('처리에 실패하였습니다. 잠시 후에 다시 시도해 주세요.');
        console.error(e);
      }
      this.executeLoading = false;
    },
    async excuteConfirmCancel() {
      if (!this.validNumber(this.userMobile)) {
        alert('연락처는 숫자만 입력해 주세요.');
        return;
      }
      if (!this.userName || !this.userMobile) {
        alert('고객 정보를 입력 후 실행해주세요.');
        return;
      } else if (!confirm('모든 상품에 대한 결제 승인이 취소됩니다.\n계속 진행하시겠습니까?')) {
        return;
      }

      try {
        this.executeLoading = true;
        const cancelResult = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/${this.claimed.ID}/cancel`,
          {
            operatorUID: this.uID,
            deviceID: this.claimed.deviceID,
            cancelPrice: parseInt(this.claimed.approvePrice, 10),
            userName: this.userName,
            userMobile: this.userMobile,
            memo: this.memo,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (cancelResult.status !== 200) {
          throw new Error(`Response status is "${cancelResult.status}"`);
        }
        if (cancelResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${cancelResult.data.resultCode}"`);
        }
        this.goList(); // TODO this.pollingResult(this.claimed.ID);
      } catch (e) {
        alert('처리에 실패하였습니다. 잠시 후에 다시 시도해 주세요.');
        console.error(e);
        this.executeLoading = false;
      }
      this.executeLoading = false; // TODO this.pollingResult(this.claimed.ID);
    },
    async executeConfirmRefund() {
      if (!this.validNumber(this.userMobile)) {
        alert('연락처는 숫자만 입력해 주세요.');
        return;
      }
      if (!this.validNumber(this.accountNum)) {
        alert('계좌번호는 숫자만 입력해 주세요.');
        return;
      }
      if (!this.userName || !this.userMobile || !this.bankName || !this.accountNum) {
        alert('고객 정보를 입력 후 실행해주세요.');
        return;
      } else if (this.refundPrice === 0) {
        alert('환불금액을 확인 후 실행해주세요.\n(환불하고자 하는 상품의 수량을 줄이십시요.)');
        return;
      } else if (!confirm(`환불금액합계 ${this.refundPrice}원을 입금처리하여 주시기 바랍니다`)) {
        return;
      }

      try {
        this.executeLoading = true;

        let encAccountNum = '';
        let encKey = '';
        if (!Configuration.valueBool('IS_STAGE')) {
          const keyiv = this.$generateAESKeyAndIV(32, 12);
          encKey = this.$jsEncrypt.encrypt(`${keyiv.key}${keyiv.iv}`);
          encAccountNum = await this.$encryptGCM(keyiv.key, keyiv.iv, this.accountNum);
        } else {
          encAccountNum = this.accountNum;
        }

        const paymentDetails = [];
        for (let i = 0; i < this.newPaymentDetails.length; i++) {
          if (this.newPaymentDetails[i].productCount > 0) {
            paymentDetails.push({
              deviceID: this.claimed.deviceID,
              trayID: this.newPaymentDetails[i].trayID,
              productID: this.newPaymentDetails[i].productID,
              productName: this.newPaymentDetails[i].productName,
              productType: this.newPaymentDetails[i].productType,
              productCount: this.newPaymentDetails[i].productCount,
              supplyPrice: this.newPaymentDetails[i].supplyPrice,
              salePrice: this.newPaymentDetails[i].salePrice,
            });
          }
        }

        const reBiilResult = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/${this.claimed.ID}/refund`,
          {
            operatorUID: this.uID,
            deviceID: this.claimed.deviceID,
            cancelPrice: parseInt(this.claimed.approvePrice, 10),
            paymentPrice: parseInt(this.totalPrice, 10),
            refundPrice: parseInt(this.refundPrice, 10),
            userName: this.userName,
            userMobile: this.userMobile,
            memo: this.memo,
            bankName: this.bankName,
            bankAccountNumber: encAccountNum,
            bankAccountHolder: this.userName,
            paymentDetails,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
              sKey: encKey,
            },
          },
        );
        if (reBiilResult.status !== 200) {
          throw new Error(`Response status is "${reBiilResult.status}"`);
        }
        if (reBiilResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${reBiilResult.data.resultCode}"`);
        }
        this.goList();
      } catch (e) {
        alert('처리에 실패하였습니다. 잠시 후에 다시 시도해 주세요.');
        console.error(e);
      }
      this.executeLoading = false;
    },
    async executeConfirmNonpayment() {
      if (!this.validNumber(this.userMobile)) {
        alert('연락처는 숫자만 입력해 주세요.');
        return;
      }
      if (!this.userName || !this.userMobile) {
        alert('고객 정보를 입력 후 실행해주세요.');
        return;
      }

      if (this.tokenID && this.tokenID.length > 0) {
        if (!confirm('선택하신 상품으로 결제 승인을 진행합니다.\n계속 진행하시겠습니까?')) {
          return;
        }
      } else if (!confirm(`${this.totalPrice}원 결제를 이미 진행하셨습니까?`)) {
        return;
      }

      try {
        this.executeLoading = true;

        const paymentDetails = [];
        for (let i = 0; i < this.newPaymentDetails.length; i++) {
          if (this.newPaymentDetails[i].productCount > 0) {
            paymentDetails.push({
              deviceID: this.claimed.deviceID,
              trayID: this.newPaymentDetails[i].trayID,
              productID: this.newPaymentDetails[i].productID,
              productName: this.newPaymentDetails[i].productName,
              productType: this.newPaymentDetails[i].productType,
              productCount: this.newPaymentDetails[i].productCount,
              supplyPrice: this.newPaymentDetails[i].supplyPrice,
              salePrice: this.newPaymentDetails[i].salePrice,
            });
          }
        }

        const reBiilResult = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/${this.claimed.ID}/nonpayment`,
          {
            operatorUID: this.uID,
            deviceID: this.claimed.deviceID,
            paymentPrice: parseInt(this.totalPrice, 10),
            tokenID: this.tokenID,
            userName: this.userName,
            userMobile: this.userMobile,
            memo: this.memo,
            paymentDetails,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (reBiilResult.status !== 200) {
          throw new Error(`Response status is "${reBiilResult.status}"`);
        }
        if (reBiilResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${reBiilResult.data.resultCode}"`);
        }
        this.goList();
      } catch (e) {
        alert('처리에 실패하였습니다. 잠시 후에 다시 시도해 주세요.');
        console.error(e);
      }
      this.executeLoading = false;
    },
    // TODO
    pollingResult(paymentID) {
      this.interval = setInterval(() => {
        this.checkResult(paymentID);
      }, 5000);
    },
    // TODO
    async checkResult(paymentID) {
      try {
        const res = await this.$http.get(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/${paymentID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }
        if (res.data.payment.resultCode !== '0000') {
          const split = res.data.payment.resultCode.split(',');
          const resultCode = split[0];
          if (resultCode === '8037') {
            if (res.data.payment.state === 104) {
              const resultMsg = 'Token없음 취소 불가능';
              alert(`${resultMsg}`);
            } else if (res.data.payment.state === 114 || res.data.payment.state === 145) {
              const resultMsg = 'Token없음 재승인 불가능';
              alert(`${resultMsg}`);
            }
          }
        }
        this.goList();
      } catch (e) {
        alert('처리에 실패하였습니다. 잠시 후에 다시 시도해 주세요.');
        console.error(e);
        this.executeLoading = false;
      }
    },
    goList() {
      this.$emit('refresh');
    },
    validNumber(n) {
      if (!n) {
        return false;
      }
      // return !isNaN(parseFloat(n)) && isFinite(n);
      const re = /^[0-9]*$/;
      return re.test(n);
    },
  },
};
</script>

<style scoped>
.claimed-detail {
  padding-bottom: 10px;
  /* height: calc(100vh - 200px); */
  overflow: auto;
}
.claimed-detail::-webkit-scrollbar-corner {
  background-color: inherit;
}
.claimed-detail::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.claimed-detail::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: gray;
}
.claimed-detail::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.claimed-detail .detail {
  display: flex;
  margin-bottom: 24px;
  width: 100%;
  height: 540px;
  background-color: #e3e5e8;
}
.claimed-detail .title {
  font-size: 18px;
  display: flex;
  margin-bottom: 5px;
}
.claimed-detail .title .title-area {
  font-size: 16px;
  width: 100%;
  margin-top: 5px;
}
.claimed-detail .title .btn-area {
  width: 40px;
}
.claimed-detail .title .btn-area .btn {
  width: 100%;
  height: 40px;
  text-align: center;
  font-size: 12.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  border-radius: 2px;
  border: solid 0.5px #686868;
  transition: 0.2s;
  cursor: pointer;
}
.detail .scroll::-webkit-scrollbar-corner {
  background-color: inherit;
}
.detail .scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.detail .scroll::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: gray;
}
.detail .scroll::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.detail .image-area {
  position: relative;
  width: 100%;
  height: 100%;
}
.detail .products {
  padding: 10px;
  padding-bottom: 0;
  min-width: 600px;
  width: 600px;
  max-width: 600px;
  height: 100%;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #192124;
  background-color: #f3f5f8;
  overflow-y: auto;
}
.image-area .images {
  display: flex;
  width: 100%;
  height: calc(100% - 16px);
}
.image-area .image {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
.image-area .sub-image {
  width: 160px;
  height: 100%;
}
.image-area .sub-image div {
  width: 160px;
  height: 90px;
  background-color: #787878;
}
.image-area .sub-image img {
  width: 160px;
  height: 90px;
}
.image-area .sub-image img.selectedTODO {
  border: solid 2px #0058ee;
}
.image-area .spinner {
  position: absolute;
  top: calc(50% - 60px);
  left: calc(50% - 60px);
}
.detail .subimages {
  padding: 0px;
  padding-left: 3px;
  padding-bottom: 0;
  min-width: 160;
  width: 100%;
  max-width: 168px;
  height: 100%;
  background-color: #f3f5f8;
  overflow-y: auto;
  border-right: 1px solid #d3d3d3;
}
.subimages {
  width: 160px;
  height: 100%;
}
.subimages div {
  width: 160px;
  height: 90px;
  background-color: #d3d3d3;
}
.subimages img {
  width: 160px;
  height: 90px;
  padding: 3px;
  border: 1px solid #f3f5f8;
}
.subimages img.selected {
  border: solid 2px #0058ee;
}
.slider {
  appearance: none;
  width: 100%;
  height: 16px;
  background-color: #d3d3d3;
  outline: none;
  --slider-width: 100%;
}
.slider::-webkit-slider-thumb {
  appearance: none;
  min-width: 16px;
  width: var(--slider-width);
  height: 16px;
  background-color: gray;
  background-image: url('/static/img/ico-drag-vertical-variant.png');
  background-size: 16px;
  border-radius: 2px;
  cursor: pointer;
}
.products .type {
  margin-bottom: 10px;
  font-size: 16px;
}
.products .product {
  display: flex;
  padding: 5px 0;
  height: 48px;
  border-bottom: solid 1px #dee0e3;
}
.products .product:last-of-type {
  margin-bottom: 28px;
}
.products .header {
  display: flex;
  border-bottom: 1px solid #707276;
}
.products .header div {
  text-align: center;
}
.products .preview {
  min-width: 40px;
  max-width: 40px;
}
.products .name {
  min-width: 190px;
  max-width: 190px;
}
.products .beforeCount, .products .afterCount {
  min-width: 110px;
}
.products .product .beforeCount, .products .product .salePrice, .products .product .price {
  padding: 7px 0;
}
.products .beforeCount, .products .afterCount {
  min-width: 100px;
  max-width: 100px;
}
.products .beforeCount .count {
  text-align: center;
  width: 100%;
}
.products .salePrice {
  min-width: 90px;
  text-align: right;
}
.products .price {
  min-width: 90px;
  text-align: right;
}
.product .ctrl {
  display: flex;
  padding: 7px 15px;
  /* margin-left: auto; */
}

.ctrl .btn {
  width: 24px;
  height: 24px;
  font-size: 18px;
  text-align: center;
  color: #707276;
  background-color: #ebeef1;
  cursor: pointer;
  user-select: none;
  transition: 0.2s;
}
.ctrl .btn:hover {
  background-color: #e0e0e0;
}
.ctrl .count {
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
}
.ctrl .count.zero {
  color: #9d9ea1;
}
.products .total {
  display: flex;
}
.products .total .title {
  min-width: 130px;
  font-size: 18px;
  color: #000;
}
.products .total .price {
  width: 100%;
  text-align: right;
  font-size: 18px;
  color: red;
}
.claimed-detail .detail.customer {
  display: block;
  margin-bottom: 24px;
  width: 100%;
  height: 100%;
  background-color: #f3f5f8;
}
.claimed-detail .detail.customer .row {
  display: flex;
  border-bottom: solid 1px #dee0e3;
}
.claimed-detail .detail.customer .col {
  height: 48px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  padding: 12px;
}
.claimed-detail .detail.customer .col.header {
  min-width: 130px;
  text-align: center;
}
.claimed-detail .detail.customer .col.input {
  padding: 8px 12px 8px 12px;
  width: 43%;
}
.claimed-detail .detail.customer .col.input.wide {
  padding: 8px 12px 8px 12px;
  width: 93%;
}
.claimed-detail .detail.customer .col.input input {
  padding: 16px 8px 16px 16px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: solid 0.5px #d3d3d3;
}
.claimed-detail .detail.pay {
  display: block;
  margin-bottom: 10px;
  width: 100%;
  height: 50px;
  background-color: #f3f5f8;
}
.claimed-detail .detail.pay .row {
  display: flex;
  border-bottom: solid 1px #dee0e3;
}
.claimed-detail .detail.pay .col {
  height: 48px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  padding: 12px;
}
.claimed-detail .detail.pay .col.header {
  min-width: 130px;
  text-align: center;
}
.claimed-detail .detail.pay .col.red {
  border: 2px solid red;
}
.claimed-detail .detail.pay .col.red.first {
  border-right: none;
}
.claimed-detail .detail.pay .col.red.last {
  border-left: none;
}
.claimed-detail .detail.pay .col.list {
  width: 60%;
}
.claimed-detail .detail.pay .col.list span {
  margin-right: 10px;
}
.claimed-detail .detail.pay .col.list img {
  vertical-align: middle;
}
.claimed-detail .detail.pay .col.approvePrice {
  width: 12%;
  text-align: right;
}
.claimed-detail .detail.pay .col.totalPrice {
    text-align: right;
    width: 12%;
    color: red;
    font-size: 16px;
}
.claimed-detail .detail.pay .col.btn {
  min-width: 200px;
  padding: 5px;
}
.claimed-detail .detail.pay .col.btn .btn {
  width: 80px;
  height: 40px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  border-radius: 4px;
  /*
  border: solid 0.5px #686868;
  */
  transition: 0.2s;
  cursor: pointer;
  color: #fff;
}
.claimed-detail .detail.payDetail {
  width: 100%;
  height: 100%;
  display: block;
  background-color: #f3f5f8;
}
.claimed-detail .detail.payDetail .row {
  display: flex;
  border-bottom: solid 1px #dee0e3;
}
.claimed-detail .detail.payDetail .row.header {
  border-bottom: 1px solid #707276;
}
.claimed-detail .detail.payDetail .col {
  height: 48px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  padding: 12px;
  min-width: 90px;
}
.claimed-detail .detail.payDetail .col.no {
  width: 5%;
  text-align: center;
}
.claimed-detail .detail.payDetail .col.name {
  width: 35%;
}
.claimed-detail .detail.payDetail .item .col.name {
  text-align: left;
}
.claimed-detail .detail.payDetail .col.salePrice {
  width: 8%;
  text-align: right;
}
.claimed-detail .detail.payDetail .col.beforeCount {
  width: 9%;
  text-align: center;
}
.claimed-detail .detail.payDetail .col.afterCount {
  width: 8%;
  text-align: center;
}
.claimed-detail .detail.payDetail .col.differenceCount {
  width: 8%;
  text-align: center;
}
.claimed-detail .detail.payDetail .item .col.differenceCount {
  color: blue;
}
.claimed-detail .detail.payDetail .item .col.differenceCount.on {
  color: red;
}
.claimed-detail .detail.payDetail .col.beforePrice {
  width: 9%;
  text-align: right;
}
.claimed-detail .detail.payDetail .col.diffrencePrice {
  width: 10%;
  text-align: right;
}
.claimed-detail .detail.payDetail .item .col.diffrencePrice {
  color: blue;
}
.claimed-detail .detail.payDetail .item .col.diffrencePrice.on {
  color: red;
}
.claimed-detail .detail.payDetail .col.afterPrice {
  width: 9%;
  text-align: right;
}
.claimed-detail .detail.payDetail .item .col.afterPrice {
  font-size: 15px;
  font-weight: 700;
}
.btn.blue {
  background-color: #0058EE;
}
.btn.blue .btn:hover {
  background-color: #0068fe;
}
.btn.orange {
  background-color: #FC8145;
}
.btn.orange .btn:hover {
  background-color: #FC8100;
}
.btn.redpink {
  background-color: #D01156;
}
.btn.redpink .btn:hover {
  background-color: #D01100;
}
</style>



// WEBPACK FOOTER //
// src/components/claim/ClaimDetail.vue